import React from "react"
import TireIcon from "../../../images/tire-confirm-img.svg"
import { Image } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import { formatPriceNumber } from "../../../shared_component/utils/helpers"
import defaultTire from "../../../images/DefaultTire.png"
import ReactSVG from "react-svg"
import CheckIcon from "../../../images/CheckIcon.svg"
import DefaultLogo from "../../../images/NoLogoAvailable.png"
import { Chip } from "../../../shared_component/elements/Chip"
import SheildIcon from "../../../images/warranty-logo.svg"
import { formatParagraph } from "../../helpers/stringHelpers"
import { NO, YES } from "../../constants/order"

const TireDetailConfirmScreen = ({ t, tire: item }) => {
  const onImageError = (e) => {
    e.target.src = TireIcon
  }

  return (
    <div className="tire-size-card tire-size-card-confirm-screen">
      <div className="tire-image-container">
        <Image
          src={item && item.image ? item.image : defaultTire}
          onError={onImageError}
          className="tire-size-image"
        />
        <div className="tire-original-description-section">
          <ReactSVG src={CheckIcon} />
          {t("topTires:originalLabel")}
        </div>
      </div>
      <div className="tire-size-details-container">
        <div className="tire-size-details-section">
          <div className="tire-size-company-details">
            <Image
              src={item.brand_logo || item.image || DefaultLogo}
              className="tire-image-brand-logo"
            />
            <div className="tire-brand-miles-details">
              {item.mileage_rating ? (
                <Chip
                  icon={SheildIcon}
                  label={`${formatPriceNumber(item.mileage_rating)} ${t(
                    "confirmOrderDialog:miles"
                  )} ${t("confirmOrderDialog:warranty")}`}
                  backgroundColor={"#F8F8F8"}
                />
              ) : null}
              {item.season ? (
                <Chip
                  label={formatParagraph(`${t("topTires:seasonLabel")}: *${item.season}*`, 600)}
                  backgroundColor={"#FEF6F4"}
                />
              ) : null}
            </div>
          </div>
          <div className="tire-size-details">
            <div className="tire-name">{item && item.brand + " " + item.model}</div>
            <div className="tire-size-details-section">
              <span className="tire-size-detail"> {item && item.size}</span>
            </div>
            <div className="tire-size-config-section">
              <div className="tire-size-config">
                {t("topTires:runFlatLabel")} <strong>{item.run_flat ? YES : NO}</strong>
              </div>
              <div className="tire-size-config">
                {t("topTires:loadRangeLabel")}{" "}
                <strong>{item.load_range ? item.load_range : "-"}</strong>
              </div>
              <div className="tire-size-config">
                {t("topTires:speedRatingLabel")}{" "}
                <strong>{item.speed_rating ? item.speed_rating : "-"}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation("confirmOrderDialog")(TireDetailConfirmScreen)
